// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__Kq_-T","gfeWrapper":"CalendarEvent_gfeWrapper__5mfXk"};